import { WidgetType } from '@/modules/ta/legacy/widget/widget.constants';
import { AccountManagerWidget } from '@/modules/ta/legacy/widget/models/AccountManagerWidget';
import { Widget } from '@/modules/ta/legacy/widget/models/Widget';
import { MediaWidget } from '@/modules/ta/legacy/widget/models/MediaWidget';

export class WidgetFactory {
  /**
   * @param {Widget|{}} widget
   * @returns {Widget}
   */
  static build(widget) {
    switch (widget.type) {
      case WidgetType.TYPE_ACCOUNTMANAGER:
        return new AccountManagerWidget(widget);
      case WidgetType.TYPE_MEDIA:
        return new MediaWidget(widget);
      default:
        if (!(widget instanceof Widget)) {
          return new Widget(widget);
        }
    }
    return widget;
  }
}
